const SaversTypes = {
  SET_SELECTED_TRAILER_REQUEST: 'SAVERS_TYPES.SET_SELECTED_TRAILER_REQUEST',
  SET_SELECTED_LOCATION_REQUEST: 'SAVERS_TYPES.SET_SELECTED_LOCATION_REQUEST',
  SET_SAVERS_ACTIVE_TAB: 'SAVERS_TYPES.SET_SAVERS_ACTIVE_TAB',
  SET_SELECTED_TRAILER_ID: 'SAVERS_TYPES.SET_SELECTED_TRAILER_ID',
  SET_SELECTED_RATE: 'SAVERS_TYPES.SET_SELECTED_RATE',
  SET_RATE_LIST: 'SAVERS_TYPES.SET_RATE_LIST',
  SET_SELECTED_RATE_RESULT: 'SAVERS_TYPES.SET_SELECTED_RATE_RESULT',
  SET_SELECTED_RATE_RESULT_INDEX: 'SAVERS_TYPES.SET_SELECTED_RATE_RESULT_INDEX',
  SET_SELECTED_RATE_RESULT_CARRIER: 'SAVERS_TYPES.SET_SELECTED_RATE_RESULT_CARRIER',
  SET_LOGGEDIN_USER_TYPE: 'SAVERS_TYPES.SET_LOGGEDIN_USER_TYPE',
  SET_SAVERS_SUPPLIER: 'SAVERS_TYPES.SET_SAVERS_SUPPLIER',
  SET_SHIPMENT_LIST: 'SAVERS_TYPES.SET_SHIPMENT_LIST',
  SET_SHIPMENT_FILTERS: 'SAVERS_TYPES.SET_SHIPMENT_FILTERS',
  GET_SHIPMENT_LIST_PROGRESS: 'SAVERS_TYPES.GET_SHIPMENT_LIST_PROGRESS',
  GET_SHIPMENT_LIST_SUCCESS: 'SAVERS_TYPES.GET_SHIPMENT_LIST_SUCCESS',
  GET_SHIPMENT_LIST_ERROR: 'SAVERS_TYPES.GET_SHIPMENT_LIST_ERROR',
};

export default SaversTypes;
